import React from 'react';
import PropTypes from 'prop-types';
import { Container, TitleStyled, SubtitleStyled } from './styles';

const PageHeader = ({
  title = '',
  subtitle = '',
  titleSize = '24px',
  titleWeight = '700',
  subtitleSize = '14px',
  subtitleWeight = '400',
  marginTop = '0px',
  marginBottom = '0px',
  dataPanel = ''
}) => {
  return (
    <Container marginTop={marginTop} marginBottom={marginBottom}>
      {title && (
        <TitleStyled data-panel={`titleHeader-${dataPanel}`} fontSize={titleSize} fontWeight={titleWeight}>
          {title}
        </TitleStyled>
      )}
      {subtitle && (
        <SubtitleStyled data-panel={`subtitleHeader-${dataPanel}`} fontSize={subtitleSize} fontWeight={subtitleWeight}>
          {subtitle}
        </SubtitleStyled>
      )}
    </Container>
  );
};

export default PageHeader;
